import React from "react"
import * as Logos from "../../images/brand-logos/logos"

export const mapConfig = {
  woosmapMapJSUrl: `https://sdk.woosmap.com/map/map.js?key=woos-19f74f73-0b20-3571-b9ef-706ad3dbad27`,
  woosmapLoaderUrl: "https://sdk.woosmap.com/locator/loader.js",
  woosmapLocalitiesUrl: "https://sdk.woosmap.com/localities/localities.2.0.js",
  woosmapMultiSearchUrl: "https://sdk.woosmap.com/multisearch/multisearch.js",
  woosmapLoadOptions: {
    version: "1.4",
    publicKey: "woos-19f74f73-0b20-3571-b9ef-706ad3dbad27",
    loadJQuery: false,
  },
  googleLoadOptions: {
    key: "AIzaSyCQjSLUj8nW49MhsSA0f-wGxavBTEh0DjA",
    language: "en",
    region: "GB",
  },
  googleMapsOptions: {
    center: {
      lat: 51.53,
      lng: -0.185,
    },
    zoom: 9,
    mapTypeControl: false,
    fullscreenControl: false,
    styles: [
      {
        featureType: "poi",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
    ],
  },
  woosmapStyleOptions: {
    style: {
      default: {
        icon: {
          url: "../../../map-pin-white.svg",
          scaledSize: {
            height: 47,
            width: 40,
          },
        },
        numberedIcon: {
          url: "../../../map-pins/{number}.svg",
          scaledSize: {
            height: 47,
            width: 40,
          },
        },
        selectedIcon: {
          url: "../../../map-pin-orange.svg",
          scaledSize: {
            height: 71,
            width: 61,
          },
        },
      },
    },
    tileStyle: {
      color: "#002e5a",
      size: 16,
      minSize: 6,
    },
    breakPoint: 10,
  },
  infoWindow: {
    disableAutoPan: false,
    alignBottom: true,
    closeBoxURL: "https://images.woosmap.com/close.svg",
    boxStyle: "width:240px",
    closeBoxMargin: "13px 8px",
    pixelOffset: {
      width: -200,
      height: 60,
    },
  },
}

export const brandList = [
  "All Bar One",
  "Browns",
  "Castle",
  "EGO Mediterranean",
  "Ember Inns",
  "Harvester",
  "High Street",
  "Innkeepers Collection",
  "Miller & Carter",
  "Nicholsons",
  "O'Neill's",
  "Premium Country Pubs",
  "Sizzling Pubs",
  "Stonehouse",
  "Toby Carvery",
  "Vintage Inns",
]

export const brandOptions = []
brandList.map((name, index) => {
  brandOptions.push({
    value: name,
    label: name,
  })
  return null
})

export const brands = [
  { id: 17, name: "All Bar One" },
  { id: 31, name: "Browns" },
  { id: null, name: "Castle" }, // Need ID
  { id: null, name: "EGO Mediterranean" },
  { id: 101, name: "Ember Inns" },
  { id: 9, name: "Harvester" },
  { id: null, name: "High Street" }, // Need ID
  { id: null, name: "Innkeepers Collection" }, // Need ID
  { id: 37, name: "Miller and Carter" },
  { id: 112, name: "Nicholsons" },
  { id: 521, name: "O'Neills" },
  { id: null, name: "Premium Country Pubs" }, // Need ID
  { id: 109, name: "Sizzling Pubs" },
  { id: 14, name: "Stonehouse" },
  { id: 524, name: "Toby Carvery" },
  { id: 8, name: "Vintage Inns" },
]

export const brandLogos = [
  {
    name: "All Bar One",
    logo: <Logos.AllBarOne />,
  },
  {
    name: "Browns",
    logo: <Logos.Browns />,
  },
  {
    name: "Castle",
    logo: <Logos.Castle />,
  },
  {
    name: "EGO Mediterranean",
    logo: <Logos.Ego />,
  },
  {
    name: "Ember Inns",
    logo: <Logos.EmberInns />,
  },
  {
    name: "Harvester",
    logo: <Logos.Harvester />,
  },
  {
    name: "High Street",
    logo: <Logos.HighStreet />,
  },
  {
    name: "Oak Tree pubs",
    logo: <Logos.HighStreet />,
  },
  {
    name: "Innkeepers Collection",
    logo: <Logos.InnkeepersCollection />,
  },
  {
    name: "Inn Keepers Collection",
    logo: <Logos.InnkeepersCollection />,
  },
  {
    name: "Miller & Carter",
    logo: <Logos.MillerAndCarter />,
  },
  {
    name: "Nicholsons",
    logo: <Logos.Nicholsons />,
  },
  {
    name: "O'Neills",
    logo: <Logos.ONeills />,
  },
  {
    name: "Premium Country Pubs",
    logo: <Logos.PremiumCountryPubs />,
  },
  {
    name: "Sizzling Pubs",
    logo: <Logos.SizzlingPubs />,
  },
  {
    name: "Stonehouse",
    logo: <Logos.Stonehouse />,
  },
  {
    name: "Toby Carvery",
    logo: <Logos.TobyCarvery />,
  },
  {
    name: "Vintage Inns",
    logo: <Logos.VintageInns />,
  },
]

export const distances = [
  {
    label: "1 mile",
    value: 1,
    default: false,
  },
  {
    label: "5 miles",
    value: 5,
    default: false,
  },
  {
    label: "10 miles",
    value: 10,
    default: true,
  },
  {
    label: "20 miles",
    value: 20,
    default: false,
  },
  {
    label: "50 miles",
    value: 50,
    default: false,
  },
]
